import { Container } from "./styles";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import Hello from "../../assets/Hello.gif";

const TypingText = ({
  text,
  delay = 0,
  hideCursorOnComplete = true,
}: {
  text: string;
  delay?: number;
  hideCursorOnComplete?: boolean;
}) => {
  const [displayedText, setDisplayedText] = useState("");
  const [isComplete, setIsComplete] = useState(false);
  const [isStarted, setIsStarted] = useState(false);

  useEffect(() => {
    const startTimer = setTimeout(() => {
      setIsStarted(true);
      let i = 0;
      const interval = setInterval(() => {
        i++;
        setDisplayedText(text.slice(0, i));
        if (i >= text.length) {
          clearInterval(interval);
          setIsComplete(true);
        }
      }, 25);
      return () => clearInterval(interval);
    }, delay * 1000);
    return () => clearTimeout(startTimer);
  }, [text, delay]);

  return (
    <span>
      <span>{displayedText}</span>
      {isStarted && (!isComplete || !hideCursorOnComplete) && (
        <span className="cursor" />
      )}
      <span style={{ visibility: "hidden" }}>
        {text.slice(displayedText.length)}
      </span>
    </span>
  );
};

export function Hero() {
  return (
    <Container id="home">
      <div className="hero-text">
        <motion.p
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          Hello <img src={Hello} alt="Hello" width="20px" />, I'm
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          Oybek Berdiyev
        </motion.h1>
        <motion.h3
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          NodeJs Backend Developer
        </motion.h3>
      </div>

      <div className="hero-image">
        <motion.div
          className="terminal"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <div className="terminal-header">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className="terminal-body">
            <div className="command">
              <TypingText text="whoami" delay={0.8} />
            </div>
            <div className="response">
              <TypingText text="oybek_berdiyev" delay={1.1} />
            </div>

            <div className="command">
              <TypingText text="location" delay={1.6} />
            </div>
            <div className="response">
              <TypingText text="Tashkent, Uzbekistan" delay={1.9} />
            </div>

            <div className="command">
              <TypingText text="skills --backend" delay={2.6} />
            </div>
            <div className="response">
              <TypingText
                text='["Node.js", "TypeScript", "PostgreSQL", "MongoDB", "Redis", "Docker"]'
                delay={3.2}
              />
            </div>

            <div className="command">
              <TypingText text="contact --status" delay={5.2} />
            </div>
            <div className="response">
              <TypingText
                text="Open for new opportunities..."
                delay={5.8}
                hideCursorOnComplete={false}
              />
            </div>
          </div>
        </motion.div>
      </div>
    </Container>
  );
}
